import { render, staticRenderFns } from "./InformationScreen.vue?vue&type=template&id=7f4e3280&scoped=true&"
import script from "./InformationScreen.vue?vue&type=script&lang=js&"
export * from "./InformationScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4e3280",
  null
  
)

export default component.exports